export const UPDATE_SALES_BY_SKU_WIDGET = "UPDATE_SALES_BY_SKU_WIDGET";